import deployments from '$lib/deployments';
import { onchainState } from '$lib/onchain/state';
import type { AvatarEntity, BombEntity } from '$lib/onchain/types';
import { derived, get } from 'svelte/store';
import { computeUpdatedLocalState, localState, type LocalAction } from '../private/localState';

export type Position = { x: number; y: number };

export type AvatarViewEntity = AvatarEntity & {
	plannedActions?: LocalAction[];
	entering: boolean;
};
export type BombViewEntity = BombEntity;
export type ViewEntity = AvatarViewEntity | BombViewEntity;
export type ViewEntities = { [id: string]: ViewEntity };
export type ViewState = {
	avatar?: { id: string; numMoves: number; numBombs: number };
	entities: ViewEntities;
	epoch: number;
};

export const viewState = derived(
	[onchainState, localState],
	([$onchainState, localStateFromStore]): ViewState => {
		const epoch = $onchainState.epoch;
		const $localState = computeUpdatedLocalState(localStateFromStore, epoch);

		const entities: ViewEntities = {};
		for (const entityID of Object.keys($onchainState.entities)) {
			const onchainEntity = $onchainState.entities[entityID];
			if (onchainEntity.type === 'avatar') {
				entities[entityID] = {
					...onchainEntity,
					entering: false
				};
			} else {
				entities[entityID] = {
					...onchainEntity
				};
			}
		}
		let avatarData: { id: string; numMoves: number; numBombs: number } | undefined;
		if ($localState.signer && $localState.avatar) {
			const currentAvatarID = $localState.avatar.avatarID;
			let avatarEntity = entities[currentAvatarID] as AvatarViewEntity | undefined;
			if (avatarEntity || !$localState.avatar.exiting) {
				let numMoves = Number(deployments.contracts.Game.linkedData.numMoves);
				let numBombs = 2;

				avatarData = {
					id: currentAvatarID,
					numMoves: numMoves - $localState.avatar.actions.filter((v) => v.type === 'move').length,
					numBombs:
						numBombs -
						$localState.avatar.actions.filter(
							(v) => v.type === 'placeBomb' || v.type === 'placeBombDelayed'
						).length
				};

				if ($localState.avatar.actions[0]?.type === 'enter') {
					avatarEntity = {
						owner: $localState.signer.owner,
						type: 'avatar',
						id: avatarData.id,
						life: 1,
						position: $localState.avatar.actions[0],
						lastEpoch: epoch,
						previousActions: [],
						entering: true
					};
					entities[avatarData.id] = avatarEntity;
				}

				if (avatarEntity) {
					const actions: LocalAction[] = [];
					let current_action: LocalAction = { type: 'move', ...avatarEntity.position };
					actions.push(current_action);
					// console.log(`current pos`, current_position);

					if ($localState.avatar.actions.length > 0 && $localState.avatar.epoch == epoch) {
						for (const action of $localState.avatar.actions) {
							current_action = { ...action };
							actions.push(current_action);
						}
					}
					avatarEntity.plannedActions = actions;
				}
			}
		}

		for (const entityID of Object.keys(entities)) {
			const entity = entities[entityID];
			if (entity.type === 'avatar' && entityID != avatarData?.id) {
				// TODO
				if (entity.life == 0 && entity.lastEpoch + 1 < epoch) {
					delete entities[entityID];
				}
			}
		}

		return {
			avatar: avatarData,
			entities,
			epoch: $onchainState.epoch
		};
	}
);

(globalThis as any).viewState = viewState;
(globalThis as any).get = get;
